/**
 * GlobalChatToggle — the phone's chat opener, a Sparkles button in the mobile
 * top row that toggles the ChatDock.
 *
 * Desktop opens the dock from `ChatEdgeHandle` instead. Both read
 * `useChatToggle`, so either is hidden on /chat routes (the dock is excluded
 * there) and when no surface is registered (nothing to open).
 */
import React from 'react';

import { Icons } from '@shared/components/ui';

import { useChatToggle } from './useChatToggle';

interface GlobalChatToggleProps {
  className?: string;
}

export const GlobalChatToggle: React.FC<GlobalChatToggleProps> = ({ className }) => {
  const { visible, isOpen, toggle } = useChatToggle();
  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isOpen ? 'Close assistant' : 'Open assistant'}
      aria-pressed={isOpen}
      className={`hover:bg-muted flex h-9 w-9 items-center justify-center rounded-md transition-colors ${
        isOpen ? 'text-brand' : 'text-muted-foreground hover:text-foreground'
      } ${className ?? ''}`}
    >
      <Icons.Sparkles size="sm" />
    </button>
  );
};
